module.exports = __webpack_public_path__ + "static/media/note.9b4fd807.svg";